<template>
    <div class="kit-product__atts">
        <div v-for="(option, x) in product.attributes" :key="x">
            <label>{{ option.title }}</label>
            <p>{{ option.option }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ProductAttributes',
        props: ['product']
    }
</script>

<style lang="scss">
    .kit {
        &-product {
            &__atts {
                > div {
                    display: grid;
                    grid-template-columns: 30% 1fr;
                    gap: 11px;
                    font-size: 10px;
                    margin-bottom: 10px;

                    > label {
                        text-transform: uppercase;
                        font-weight: 600;
                    }
                }
            }
        }
    }
</style>